/**
 * Auto-generated file - do not edit by hand
 * Run `pnpm ui:generate:icons` to regenerate
 * Source: source/svg/warning.svg
 */
import type { IconProps } from '../types';
const Warning = ({ size, ...props }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.8}
      d="M12 8.75v4m0 2.75v-.01m.25.01a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm-9.453.728L10.281 3.64c.775-1.304 2.663-1.304 3.438 0l7.484 12.587c.793 1.333-.168 3.022-1.719 3.022H4.516c-1.55 0-2.512-1.69-1.719-3.022Z"
    />
  </svg>
);
export default Warning;
